<div class="camera-wrap">
    <webcam [height]="300" [width]="util.isMobile ? 280 : 350" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
        *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
        [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
        (initError)="handleInitError($event)">
    </webcam>

    <div class="custom_cam_section">
        <p-button (click)="triggerSnapshot();" icon="pi pi-bookmark" pTooltip="Take picture" [rounded]="true"
            severity="secondary"></p-button>
    </div>
</div>
